export const labels = {
	add: {
		label: "Label.MobileCreator.BottomMenu.Qr.Add",
		default: "Add",
		// description: "The adds a new QR code to the page"
	},
	edit: {
		label: "Label.MobileCreator.BottomMenu.Qr.Edit",
		default: "Edit",
	},
	delete: {
		label: "Label.MobileCreator.BottomMenu.Qr.Delete",
		default: "Delete",
	},
};
